import React from 'react';

export default function UploadIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 967.86 587.77">
      <g>
        <g>
          <path d="M795.42,242.88c-1.31,0-2.61,0-3.91.05A172.52,172.52,0,0,0,542.46,127,207.84,207.84,0,0,0,351,0C236.21,0,143.18,93,143.18,207.78a209,209,0,0,0,4.3,42.22A169.2,169.2,0,0,0,169.2,587H418.49V441.39H354.83c-19.26,0-30.17-22.07-18.48-37.38l129.1-169.08a23.26,23.26,0,0,1,37,0L631.52,404c11.68,15.31.77,37.38-18.49,37.38H549.37V587H779.21c5.33.5,10.74.77,16.21.77s10.87-.27,16.21-.77h0a172.44,172.44,0,0,0-16.21-344.12Z" />
        </g>
      </g>
    </svg>
  );
}
